import React, {Component} from 'react';
import {withFirebase} from "../Firebase";
import Header from "../Header";
import {withAdmin} from "../Session/context";
import languages from "../../utils/languages";
import * as JSZip from 'jszip';
import { saveAs } from 'file-saver';
import {escapePhrase} from "../../utils/parser";

class PageDownload extends Component {

    constructor(props) {
        super(props);
        this.state = {
            projects: [],
        }
    }

    componentDidMount() {
        this.props.firebase.getProjects().then(projects => {
            this.setState({
                projects: projects,
                selected: projects[0].id
            })
        });
    }

    changedProject = (event) => {
        this.setState({
            selected: event.target.value
        })
    };

    convertTranslationsToStringsFile = (translations) => {
        const lines = ["<resources>"];
        if(translations) {
            Object.entries(translations).forEach(([key,value]) => {
                lines.push(`    <string name="${key}">${escapePhrase(value)}</string>`);
            });
        }
        lines.push("</resources>");
        return lines.join("\n");
    };

    export = async (event) => {
        event.preventDefault();

        const projectId = this.state.selected;
        const zip = new JSZip();

        const project = await this.props.firebase.getProject(projectId);
        const strings = project.strings;

        for(const [key,value] of Object.entries(languages)) {
            const folder = zip.folder(`values-${key}`);
            const existingTranslations = await this.props.firebase.getExistingTranslations(projectId,key);

            if(!existingTranslations) {
                continue;
            }

            const filteredTranslations = {};

            Object.keys(existingTranslations).forEach(key => {
                if(strings[key]) {
                    filteredTranslations[key] = existingTranslations[key]
                }
            });

            const stringsFile = this.convertTranslationsToStringsFile(filteredTranslations);
            folder.file("strings.xml",stringsFile);
        }

        zip.generateAsync({type: "blob"})
            .then(function(content) {
                // see FileSaver.js
                saveAs(content, `strings_${projectId}.zip`);
            });
    };

    render() {

        if(!this.state.projects) return null;

        const options = this.state.projects.map(project => (<option key={project.id} value={project.id}>{project.title}</option>));

        return (
            <div>
                <Header title={`Download`} subtitle={`Translations`} />
                <select value={this.state.selected} onChange={this.changedProject}>
                    {options}
                </select>
                <input type="button" value="Download (it will take a few seconds)" onClick={this.export} />
            </div>
        );
    }
}

export default withAdmin(withFirebase(PageDownload));